import { Linkedin, Mail, Youtube, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PhoneLink } from "@/components/ui/phone-link";
import { PhoneButton } from "@/components/ui/phone-button";
import { PHONE_NUMBERS } from "@/constants/contact";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-100">
      {/* edgefi Brand Book - Version 1.0 - Last Updated: 3/20/25 */}
      <div className="mx-auto max-w-7xl px-6 py-16 md:py-24 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          <div className="lg:col-span-2">
            <img
              src="/lovable-uploads/6e88f8b3-0ddf-4ad8-9625-adcf5c8d9671.png"
              alt="edgefi Logo"
              className="h-10 w-auto mb-8"
            />
            <p className="text-sm leading-6 text-gray-600 mb-6">
              Transforming cybersecurity from a cost center into a strategic business enabler. We help organizations optimize their security investments.
            </p>
            
            {/* Contact Section */}
            <div className="mb-8">
              <h4 className="text-lg font-semibold text-gray-900 mb-6">Contact Us</h4>
              
              <div className="space-y-5">
                <div className="pb-3">
                  <PhoneLink
                    phoneNumber={PHONE_NUMBERS.SALES.href}
                    formatted={PHONE_NUMBERS.SALES.formatted}
                    label={PHONE_NUMBERS.SALES.label}
                    phoneType="sales"
                    trackingContext="footer"
                    showIcon={false}
                    className="text-gray-900 hover:text-gray-700 font-medium"
                  />
                </div>
                
                <div className="pt-2">
                  <PhoneLink
                    phoneNumber={PHONE_NUMBERS.SUPPORT.href}
                    formatted={PHONE_NUMBERS.SUPPORT.formatted}
                    label={PHONE_NUMBERS.SUPPORT.label}
                    phoneType="support"
                    trackingContext="footer"
                    showIcon={false}
                    className="text-gray-900 hover:text-gray-700 font-medium"
                  />
                </div>
              </div>
              
              <div className="mt-4 pt-4 border-t border-gray-200">
                <p className="text-xs text-gray-500">Mon-Fri: 8AM-5PM PST</p>
              </div>
            </div>
            
            <div className="flex space-x-6">
              <a href="https://www.linkedin.com/company/edgefi-cyber/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-purple-600 transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="https://www.youtube.com/@edgefi-cyber" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-purple-600 transition-colors">
                <Youtube className="h-5 w-5" />
              </a>
              <Link to="/get-started" className="text-gray-400 hover:text-purple-600 transition-colors">
                <Mail className="h-5 w-5" />
              </Link>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold leading-6 text-gray-900 mb-6">Solutions</h3>
            <ul role="list" className="space-y-5">
              <li>
                <Link to="/services/cybersecurity-advisory" className="text-sm leading-6 text-gray-500 hover:text-purple-600 transition-colors">
                  Security Assessment
                </Link>
              </li>
              <li>
                <Link to="/services/microsoft-365-security" className="text-sm leading-6 text-gray-500 hover:text-purple-600 transition-colors">
                  Implementation Support
                </Link>
              </li>
              <li>
                <Link to="/services/managed-services" className="text-sm leading-6 text-gray-500 hover:text-purple-600 transition-colors">
                  Managed Services
                </Link>
              </li>
              <li>
                <Link to="/resources/security-guide" className="text-sm leading-6 text-gray-500 hover:text-purple-600 transition-colors">
                  Security Field Guide
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold leading-6 text-gray-900 mb-6">Company</h3>
            <ul role="list" className="space-y-5">
              <li>
                <Link to="/about" className="text-sm leading-6 text-gray-500 hover:text-purple-600 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-sm leading-6 text-gray-500 hover:text-purple-600 transition-colors">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm leading-6 text-gray-500 hover:text-purple-600 transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/get-started" className="text-sm leading-6 text-gray-500 hover:text-purple-600 transition-colors">
                  Contact Sales
                </Link>
              </li>
              <li className="pt-2">
                <Link to="/get-started">
                  <Button 
                    variant="outline" 
                    className="w-full border-purple-600 text-purple-600 hover:bg-purple-50 rounded-full"
                  >
                    Schedule a Call
                  </Button>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-16 pt-8 border-t border-gray-100">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-xs leading-5 text-gray-400">&copy; {new Date().getFullYear()} edgefi. All rights reserved.</p>
            <div className="mt-4 md:mt-0 flex items-center">
              <Link to="/privacy" className="flex items-center text-xs text-gray-400 hover:text-purple-600 transition-colors">
                <Shield className="h-3.5 w-3.5 mr-1.5" />
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
